import { useState } from "react";
import { Modal } from "react-bootstrap";
import ContractActivity from "../ContractActivity";
import _ from "lodash";

const ContractLinkComponent = (props: any) => {
  const [isPopupOpened, setIsPopupOpened] = useState<boolean>(false);

  const onLinkClick = async (event: any) => {
    event.preventDefault();
    setIsPopupOpened(true);
  };

  return (
    <div>
      {!props.data.isTotalRow && _.isString(props.value) && (
        <a href="#" onClick={onLinkClick}>
          {" "}
          {props.value}
        </a>
      )}

      {(props.data.isTotalRow || !_.isString(props.value)) && (
        <div> {props.value}</div>
      )}
      <Modal
        size="lg"
        centered
        show={isPopupOpened}
        onHide={() => setIsPopupOpened(false)}
        backdrop="static"
      >
        <Modal.Header
          style={{
            backgroundColor: "#6a7587",
            color: "#fff",
            height: "3rem",
          }}
          closeButton
        >
          <Modal.Title>
            Contract Activity (
            {props?.data?.contract_id_new
              ? props?.data?.contract_id_new
              : props?.data?.contract_id}
            /{props?.data?.bl ? props?.data?.bl : props?.data?.contract_type})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ContractActivity
            contractId={
              props?.data?.contract_id_new
                ? props?.data?.contract_id_new
                : props?.data?.contract_id
            }
            contractType={
              props?.data?.bl ? props?.data?.bl : props?.data?.contract_type
            }
          ></ContractActivity>
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default ContractLinkComponent;
